var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, attachKey2click, SurveyElementBase } from "survey-react-ui";
var SwitcherComponent = /** @class */ (function (_super) {
    __extends(SwitcherComponent, _super);
    function SwitcherComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SwitcherComponent.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SwitcherComponent.prototype.getStateElement = function () {
        return this.item;
    };
    SwitcherComponent.prototype.renderElement = function () {
        var _this = this;
        var tooltip = this.item.tooltip || this.item.title;
        var title = this.item.hasTitle ? React.createElement("span", { className: "svc-switcher__title" }, this.item.title) : null;
        var button = attachKey2click(React.createElement("button", { className: this.item.getActionBarItemCss(), type: "button", disabled: this.item.disabled, onClick: function (args) { return _this.item.action(_this.item, _this.item.getIsTrusted(args)); }, title: tooltip, "aria-checked": this.item.ariaChecked, "aria-expanded": this.item.ariaExpanded, role: this.item.ariaRole },
            React.createElement("div", { className: this.item.getSwitcherIconCss() },
                React.createElement("div", { className: "svc-switcher__icon-thumb" })),
            title), this.item, { processEsc: false });
        return button;
    };
    return SwitcherComponent;
}(SurveyElementBase));
export { SwitcherComponent };
export default SwitcherComponent;
ReactElementFactory.Instance.registerElement("svc-switcher", function (props) {
    return React.createElement(SwitcherComponent, props);
});
